import { render, staticRenderFns } from "./PowerPacketsBlock.vue?vue&type=template&id=1d90d15d"
import script from "./PowerPacketsBlock.vue?vue&type=script&lang=ts"
export * from "./PowerPacketsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports